import React, { useEffect, useState } from "react";
import overlayVideo from "../files/banner.mp4";
import logo from "./logo-black.png.webp";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "./firebase";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import { websites } from "../constants/websites";
import AdminLogin from "./AdminLogin";
import { getmyip, googleLogin, manualLogin } from "../redux/actionCreator";

const Login = () => {
  const { site } = useParams();
  const [ip, setIP] = useState('');
  const [admin, setAdmin] = useState(false)
  const [err, setErr] = useState({});
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  useEffect(() => {
    getSystempublicIp();
  }, []);
  const getSystempublicIp = async () => {
    let response = await getmyip();
    console.log(response)
    setIP(response.ip);
  }
  const onChangeHandler = (key, value) => {
    setData({
      ...data,
      [key]: value,
    });
    setErr({
      ...err,
      [key]: "",
    });
  };

  const onEnterLogin = (e) => {
    if (e.key == "Enter") {
      handleSubmit();
    }
  };

  const validate = () => {
    let temp = {};
    if (data?.email?.trim() == "") {
      temp = { ...temp, email: "Please enter email" };
    }
    // else {
    //   let regex = new RegExp(
    //     `/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/`
    //   );
    //   if (!regex.test(data?.email?.trim())) {
    //     temp = {
    //       ...temp,
    //       email: "Please enter valid email",
    //     };
    //   }
    // }
    if (data?.password.trim() == "") {
      temp = { ...temp, password: "Please enter password" };
    }
    if (Object.values(temp).length != 0) {
      setErr(temp);
      return false;
    } else {
      setErr({});
      return true;
    }
  };

  const handleSubmit = async () => {
    if (validate()) {
      let value = {
        email: data?.email,
        password: data?.password,
      };

      console.log(value);
      try {
        let response = await manualLogin(value);
        console.log(response, "res", response?.data?.accessToken);
        if (response?.data?.status) {
          if (websites?.[site]) {
            console.log(websites?.[site] + response?.data?.accessToken);
            window.location.replace(
              websites?.[site] + response?.data?.accessToken
            );
          } else {
            console.log(response,'responseresponse')
            localStorage.removeItem("role")
            localStorage.setItem("token", response?.data?.accessToken);
            // window.location.href = "/dashboard";
          }
        } else {
          toast.error("Login failed", {
            position: "bottom-center",
            autoClose: 3000,
          });
        }
      } catch (error) {
        toast.error("Login failed", {
          position: "bottom-center",
          autoClose: 3000,
        });
      }
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const token = await result.user.getIdToken();
      let data = {
        idToken: token,
        ip: ip
      };
      let response = await googleLogin(data);
      console.log(response, "response");
      if (response?.data?.status) {
        if (websites?.[site]) {
          console.log(websites?.[site] + response?.data?.accessToken);
          window.location.replace(
            websites?.[site] + response?.data?.accessToken
          );
        } else {
          console.log(response,'responseresponse')
          localStorage.setItem("token", response?.data?.accessToken);
          window.location.href = "/dashboard";
        }
      } else {
        console.log("2")
        // toast.error("Login failed", {
        //   position: "bottom-center",
        //   autoClose: 3000,
        // });
      }
    } catch (error) {
      console.log("1")
      // toast.error("Login failed", {
      //   position: "bottom-center",
      //   autoClose: 3000,
      // });
      console.error(error);
    }
  };

  return (
    <div className="security__login">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 pe-0">
            <div className="login__section">
              <img src={logo} alt="Smart Hatch Technologies" className="logo" /> <br />
              {
                admin ? <AdminLogin setAdmin={setAdmin} /> :
                  <>
                    <h2>Welcome back, Smarthatch Security!</h2>
                    <button onClick={handleGoogleLogin} className="btn-primary"> <img src="/google.svg" alt="" /> Login with Google</button>
                    <Link onClick={() => setAdmin(!admin)} className="admin_login mt-3">Admin login</Link>
                  </>
              }

            </div>
          </div>
        </div>
        <p className="m-0 copyright">© SMART HATCH TECHNOLOGIES FZE</p>
      </div>
    </div>
  );
};

export default Login;
